import { render, staticRenderFns } from "./Notedropq.vue?vue&type=template&id=2d9d3ca2&scoped=true&"
import script from "./Notedropq.vue?vue&type=script&lang=js&"
export * from "./Notedropq.vue?vue&type=script&lang=js&"
import style0 from "./Notedropq.vue?vue&type=style&index=0&id=2d9d3ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d3ca2",
  null
  
)

export default component.exports